"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceSelectionStrategy = void 0;
var ResourceSelectionStrategy;
(function (ResourceSelectionStrategy) {
    /** client provided nothing */
    ResourceSelectionStrategy["UNKNOWN_SELECTION_METHOD"] = "UNKNOWN_SELECTION_METHOD";
    /** client picked resource id */
    ResourceSelectionStrategy["SPECIFIC_RESOURCE"] = "SPECIFIC_RESOURCE";
    /** client explicitly asked for "any" */
    ResourceSelectionStrategy["ANY_RESOURCE"] = "ANY_RESOURCE";
    /** client cannot choose resource */
    ResourceSelectionStrategy["NO_SELECTION"] = "NO_SELECTION";
})(ResourceSelectionStrategy = exports.ResourceSelectionStrategy || (exports.ResourceSelectionStrategy = {}));
//# sourceMappingURL=slot.dto.js.map